import { jsx as _jsx } from "react/jsx-runtime";
import { PartitionOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { v4 } from "uuid";
import { useReleaseDependenciesGet } from "../../../../../hooks/useReleaseDependencies.js";
import { useTranslation } from "../../../../../others/i18n.js";
import { useStores } from "../../../../../store/root.js";
import { ReleaseCreate } from "../release-create.js";
const ReleaseModalStepTwo = (props)=>{
    const { t } = useTranslation();
    const { notificationStore } = useStores();
    const { spinning, selectedServiceIds, selectedContentBlockerIds, serviceValidations, contentBlockerValidations, onValidationChange, onReleasableIdsChange } = props;
    // States
    const [dependencyRequestRef, setDependencyRequestRef] = useState(undefined);
    const [dependencyRequestIds, setDependencyRequestIds] = useState(undefined);
    const [releaseCheck, setReleaseCheck] = useState(undefined);
    const [isValid, setIsValid] = useState(false);
    // Queries
    const dependenciesQuery = useReleaseDependenciesGet(dependencyRequestRef, dependencyRequestIds);
    const { data: dependencyData, isFetching, error: dependencyFetchError } = dependenciesQuery;
    // Effects
    useEffect(()=>{
        if (selectedServiceIds.length > 0 || selectedContentBlockerIds.length > 0) {
            setDependencyRequestIds({
                serviceIds: selectedServiceIds?.join(","),
                contentBlockerIds: selectedContentBlockerIds?.join(",")
            });
            setDependencyRequestRef(`dependency-request-${v4()}`);
        }
    }, [
        selectedServiceIds,
        selectedContentBlockerIds
    ]);
    useEffect(()=>{
        if (dependencyData) {
            onReleasableIdsChange?.(dependencyData);
        } else if (dependencyFetchError) {
            notificationStore.addFromServerError(dependencyFetchError, t);
        }
    }, [
        dependencyData,
        dependencyFetchError
    ]);
    useEffect(()=>{
        setReleaseCheck({
            dependencies: dependencyData,
            serviceValidations,
            contentBlockerValidations
        });
        if (dependencyData && serviceValidations && contentBlockerValidations) {
            // check validations for relevant dependencies
            const { contentBlockerIds, serviceIds } = dependencyData;
            const anyBlocker = contentBlockerValidations.find((validation)=>contentBlockerIds.includes(validation.id));
            const anyService = serviceValidations.find((validation)=>serviceIds.includes(validation.id));
            setIsValid(!anyBlocker && !anyService);
        }
    }, [
        serviceValidations,
        contentBlockerValidations,
        dependencyData
    ]);
    useEffect(()=>{
        onValidationChange?.(isValid);
    }, [
        isValid
    ]);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: spinning || isFetching,
        indicator: /*#__PURE__*/ _jsx(PartitionOutlined, {}),
        size: "large",
        tip: t("Checking dependencies ..."),
        children: /*#__PURE__*/ _jsx(ReleaseCreate, {
            releaseCheck: releaseCheck
        })
    });
};
export { ReleaseModalStepTwo };
